import type { PropsWithChildren, RefObject } from 'react';

import { Layer, LayersProvider, useLayerManagerFactory } from '#@/plumbing/LayerManager';
import { useClickOutside } from '#@/shared/hooks/useClickOutside';

export type ManagedLayerProps = PropsWithChildren<{
  isOpen: boolean;
  onClose(): void;
  triggerRef: RefObject<HTMLElement>;
  wrapperRef: RefObject<HTMLElement>;
  additionalRefs?: Array<RefObject<HTMLElement>>;
}>;

export default function ManagedLayer({
  children,
  isOpen,
  onClose,
  triggerRef,
  wrapperRef,
  additionalRefs = [],
}: ManagedLayerProps) {
  const childManager = useLayerManagerFactory();
  const childLayers = childManager.activeLayers.size;

  useClickOutside([wrapperRef, triggerRef, ...additionalRefs], onClose, {
    condition: childLayers === 0 && isOpen,
  });

  return (
    <Layer isOpen={isOpen}>
      <LayersProvider manager={childManager}>{children}</LayersProvider>
    </Layer>
  );
}
